<template>
  <div ref="wrapperRef" class="relative">
    <div v-if="canRead" class="font-bold pb-2 mt-8 flex items-center gap-2">
      <slot name="title" />
      <div class="flex-1" />
      <slot name="actions" />
    </div>

    <div class="flex flex-col gap-1 border-t border-gray-200 py-2">
      <slot name="content" />
    </div>

    <DropIndicator :edge="draggable.edge" />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";

import { useReorderableListItem } from "@/lib/pragmatic-dnd";
import DropIndicator from "@/lib/pragmatic-dnd/DropIndicator.vue";
import { useStore as useScaffoldingStore } from "@/store/stores/scaffolding";
import { Permission } from "@/types/account";

const props = defineProps<{
  index?: number;
  permission?: keyof Permission["permissions"];
}>();

const wrapperRef = ref<HTMLDivElement>();
const draggable = useReorderableListItem({
  element: () => wrapperRef.value,
  index: () => props.index ?? -1,
});

const scaffoldingStore = useScaffoldingStore();
const currentPermissions = computed(() => {
  return scaffoldingStore.currentPermissions;
});
const canRead = computed(() => {
  if (!props.permission) {
    return true;
  }

  return currentPermissions.value[props.permission] !== undefined;
});
</script>
